// Resolve a product image URL (backend-relative paths get the backend prefix).
// Cloudinary images get f_auto,q_auto (format/quality optimization only — no
// visual change) unless they are SVGs or already carry transformations.
export const productImage = (url) => {
  if (!url) return url;
  const resolved = url.startsWith('/') ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url;
  if (
    resolved.includes('res.cloudinary.com') &&
    resolved.includes('/upload/v') &&
    !resolved.toLowerCase().endsWith('.svg')
  ) {
    return resolved.replace('/upload/v', '/upload/f_auto,q_auto/v');
  }
  return resolved;
};
